import { Link as RouterLink } from '@tanstack/react-router'
import { Flex, Link } from '@radix-ui/themes'

interface InstallationIdLinksProps {
  installationIds: number[]
}

export const InstallationIdLinks = ({ installationIds }: InstallationIdLinksProps) => (
  <Flex gap="2" wrap="wrap">
    {installationIds.map((installationId) => (
      <Link key={installationId} size="2" asChild>
        <RouterLink to="/installations/$installationId" params={{ installationId: String(installationId) }}>
          #{installationId}
        </RouterLink>
      </Link>
    ))}
  </Flex>
)
